import { forwardRef, useCallback, useEffect, useState } from 'react'
import { ButtonProps } from './props'
import { EndIcon, StartIcon, StyledButton } from './styles'

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
    (
        {
            children,
            disabled,
            delayThrottle = 1000,
            enableThrottle = false,
            endIcon,
            onClick,
            startIcon,
            ...props
        },
        ref
    ) => {
        const [isDisabled, setIsDisabled] = useState(disabled)

        const throttleOnClick = useCallback(
            (e: React.MouseEvent<HTMLButtonElement>) => {
                onClick?.(e)
                if (enableThrottle) {
                    setIsDisabled(true)
                    setTimeout(() => setIsDisabled(false), delayThrottle)
                }
            },
            [delayThrottle, enableThrottle, onClick]
        )

        useEffect(() => setIsDisabled(disabled), [disabled])

        return (
            <StyledButton
                {...props}
                ref={ref}
                onClick={throttleOnClick}
                disabled={isDisabled}
            >
                {startIcon && <StartIcon>{startIcon}</StartIcon>}
                {children}
                {endIcon && <EndIcon>{endIcon}</EndIcon>}
            </StyledButton>
        )
    }
)

Button.displayName = 'Button'

export default Button

export { StyledButton }
